import { Search } from "lucide-react";

interface SearchPillProps {
  onClick?: VoidFunction;
  label?: string;
  shortcut?: string;
}

export function SearchPill({
  onClick,
  label = "Search for a patient",
  shortcut = "⌘/",
}: SearchPillProps) {
  return (
    <button
      onClick={onClick}
      className="flex cursor-pointer items-center gap-2.5 rounded-lg bg-[#F1F1F3] px-4 py-2 text-sm font-medium text-[#5B6472] transition-all duration-150 ease-out hover:bg-[#E3E5E9]"
    >
      <Search className="size-[17px] shrink-0" />
      <span className="whitespace-nowrap">{label}</span>
      <span className="ml-1">{shortcut}</span>
    </button>
  );
}
